import { Alert, Box, styled } from '@mui/material';
import { SCHEDULE_COMPONENT_SCREEN_BORDER_WIDTH } from 'src/constants';

export const ALERT_BOX_HEIGHT = 48;

const BaseWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ScreenBuilderWrapper = styled(BaseWrapper)`
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

export const ScreenTitleWrapper = styled(BaseWrapper)`
  gap: 8px;
  margin-bottom: 16px;
`;

export const StyledAlert = styled(Alert)`
  justify-content: center;
  width: fit-content;
  min-width: 300px;
  min-height: ${ALERT_BOX_HEIGHT}px;
`;

export const ScreenSectionsWrapper = styled(Box)`
  position: relative;
`;

export const SectionsWithComponentsWrapper = styled(Box)`
  position: absolute;
  top: 0;
  margin: ${SCHEDULE_COMPONENT_SCREEN_BORDER_WIDTH}px;
`;
